module.exports = __webpack_public_path__ + "static/esther-perel-8a551788a6f8fcc074a1695da8e8a669.jpg";